import React from 'react'
import { overlayButtonStyle } from "../../../utils/layout";
import { useEffect, useState } from "react";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import SimpleResourceItems from './SimpleResourceItems';
import Button from "react-bootstrap/esm/Button";
import { useNavigate } from 'react-router-dom';
import NoResourceMessage from './NoResourceMessage';

function PrintableActivities() {
    const [pdfResourceItems, setPdfResourceItems] = useState([]);
    const [dataPulled, setDataPulled] = useState(false);
    const navigate = useNavigate();
    const handleResourceData = async () => {
        const response = await makeGetRequest(
        urls.resources + "?active=True&resource_type=11",
        "",
        true
        );
        setPdfResourceItems(response.data);
        setDataPulled(true);
    };

    useEffect(() => {
        handleResourceData();
    }, []);

  return (
        <>
            <Button
                style={overlayButtonStyle(0)}
                onClick={() => navigate('/resource-selector')}
            >
                Back to resources
            </Button>
            {pdfResourceItems.length === 0 & dataPulled === true ? <NoResourceMessage /> : <SimpleResourceItems items={pdfResourceItems} overlayRow={1} />}
            </>
  )

}

export default PrintableActivities